import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFormRoutingContext } from 'FormsUI/components/editor/options/routing/FormRoutingProvider';
import { getListsFromRouting, getPolicyIndicesWithIdentifier, listContainsField } from 'FormsUI/utils/Routing';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';

// @ts-expect-error untyped dependency
import { getDependentFieldsOfField } from 'FormsUI/selectors/FormDefinition';
const useFieldInRouting = ({
  name,
  objectTypeId
}) => {
  const {
    routing,
    actions
  } = useFormRoutingContext();
  const formFieldId = getPropertyObjectTypeId({
    name,
    objectTypeId
  });
  const dependentFields = useSelector(state => getDependentFieldsOfField(state, {
    formFieldId
  }));
  const {
    formRouting,
    formRoutingEnabled
  } = routing;
  const {
    deleteFields
  } = actions;
  const dependentFieldIdentifiers = dependentFields.map(dependentField => getPropertyObjectTypeId(dependentField));
  const isUsedInRouting = useMemo(() => {
    if (formRouting && formRoutingEnabled) {
      const lists = getListsFromRouting(formRouting);
      return listContainsField(lists, objectTypeId, name);
    }
    return false;
  }, [formRouting, formRoutingEnabled, objectTypeId, name]);
  const isDependentFieldUsedInRouting = useMemo(() => {
    if (formRouting && formRoutingEnabled) {
      const lists = getListsFromRouting(formRouting);
      return dependentFields.some(dependentField => listContainsField(lists, dependentField.objectTypeId, dependentField.name));
    }
    return false;
  }, [dependentFields, formRouting, formRoutingEnabled]);
  const removeRoutingFieldHandler = useCallback(() => {
    if (formRouting && !formRoutingEnabled) {
      const indices = [];
      dependentFieldIdentifiers.forEach(dependentFieldIdentifier => {
        const policyIndicesForDependentFields = getPolicyIndicesWithIdentifier(formRouting, dependentFieldIdentifier);
        indices.push(...policyIndicesForDependentFields);
      });
      const policyIndices = getPolicyIndicesWithIdentifier(formRouting, formFieldId);
      indices.push(...policyIndices);
      deleteFields(indices);
    }
  }, [formRouting, formRoutingEnabled, dependentFieldIdentifiers, deleteFields, formFieldId]);
  return useMemo(() => ({
    formRouting,
    isUsedInRouting,
    isDependentFieldUsedInRouting,
    removeRoutingFieldHandler
  }), [formRouting, isUsedInRouting, isDependentFieldUsedInRouting, removeRoutingFieldHandler]);
};
export default useFieldInRouting;